import { EMPTY_MASTER_CHARGE_TYPEANY_MODEL } from "presentation/model/ChargeType/ChargeTypeMaintenanceModel"; 
import { useState } from "react"; 
import { createContainer } from "react-tracked"; 
const { 
    Provider: ChargeTypeMaintenanceProvider, 
    useTracked: useChargeTypeMaintenanceTracked 
} = createContainer(() => useState(EMPTY_MASTER_CHARGE_TYPEANY_MODEL), {concurrentMode: true}); 
export { ChargeTypeMaintenanceProvider, useChargeTypeMaintenanceTracked }; 
